'use strict';

export default class ProcedureStatusController {

  /*@ngInject*/

  constructor($http, Auth, $scope,$timeout, ProcedureStatusService, $window, $state) {
    this.Auth = Auth;
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$window = $window;
    this.ProcedureStatusService = ProcedureStatusService.setTheStates();
    this.$state = $state;
  }

  //Initialize the data on the redirection to the first page after login

  fetchData = () => {
    console.log('fetching..');
    this.$http.get('/api/schedules/patientPortal/')
      .then(response => {
        this.$scope.timeFrom = {
      opened: false
    };
        this.$scope.timeTo = {
      opened: false
    };
        this.$scope.reviewValues = {
      selectedOption: 'Patient',
      value: ['Patient', 'Parent', 'Spouse', 'Significant Other', 'Guardian']
    };
        //defining the three scopes just to ease the flow of the binding(does not create variable overhead)
        this.$scope.pending = [];
        this.$scope.verified = [];
        this.$scope.rejected = [];
        console.log("Got " + response.data.length);

        for (let i = 0; i < response.data.length; i++) {
          //check the state of the procedure
          if (response.data[i].verificationState == 'pending') {
            response.data[i].verifyPageDiv = true
            this.$scope.pending.push(response.data[i]);
          }
          if (response.data[i].verificationState == 'verified') {
            this.$scope.verified.push(response.data[i]);
          }
          if (response.data[i].verificationState == 'rejected') {
            response.data[i].rejectPageDiv = true
            this.$scope.rejected.push(response.data[i]);
          }
        }

        // Activate light gallery now.
        setTimeout(function(){
            console.log("Activating light gallery..");
            $('#light-gallery').lightGallery({
                selector: '.gallery-item'
            });
        }, 1000);


      })
      .catch(error => {
        throw error;
      });
  }


  $onInit() {
    this.Auth.getCurrentUser()
      .then((currentUser)=> {
        if(currentUser.role == 'safestartadmin') {
          console.log('Is SafeStartAdmin..')
          this.$state.go('manager');
        }
        else if(currentUser.role == 'groupadmin') {
          console.log('Is GroupAdmin....')
          this.$state.go('groupAdmin');
        }
        else {
          if(currentUser.staffRole) {
            this.$state.go('physician')
          }
          else {
            this.fetchData()
          }
        }
      })
  }


  verifyRejectProcedure(verifiedData, status) {

      if(!verifiedData) {
          console.log("Invalid data for verification");
          return;
      }

    console.log(status);                    //check the status here
    console.log(verifiedData._id);          //for testing purpose(to compare the id)

    if (status == 'verified') {
      this.$scope.verifyDiv = true;
      $('#verifyAccept').modal('hide');
    }

    if (status == 'rejected') {

      if (this.$scope.rejectionReason == "" || this.$scope.rejectionReason == undefined || this.$scope.reviewer == "" || this.$scope.reviewer == undefined) {
        if(this.$scope.rejectionReason == "" || this.$scope.rejectionReason == undefined){
          alert("Message is mandatory")
        }
        console.log(this.$scope.rejectionReason);
        $('#verifyReject').modal('hide');
        return;
      }
      this.$scope.rejectDiv = true;
      $('#verifyReject').modal('hide');

    }

    this.$window.scrollTo(0, 0);

    this.$timeout( () => {
      this.$scope.verifyDiv = false;
      this.$scope.rejectDiv = false;
      this.clearTheFields();
    }, 1500);


    this.$http.post('/api/schedules/verificationStatus/' + verifiedData._id + '/' + status, {"rejectionReason": this.$scope.rejectionReason, "reviewer": this.$scope.reviewer })
      .then(response => {
        console.log(response);
        return this.fetchData();
      })
      .catch(error => {
        throw error;
      });
  }

  clearTheFields() {
    this.$scope.rejectionReason = "";
    this.$scope.reviewer = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/account/procedureStatus/procedureStatus.controller.js